import { render, staticRenderFns } from "./pinkdetail.vue?vue&type=template&id=6b78db3c&scoped=true&"
import script from "./pinkdetail.vue?vue&type=script&lang=js&"
export * from "./pinkdetail.vue?vue&type=script&lang=js&"
import style0 from "./pinkdetail.vue?vue&type=style&index=0&id=6b78db3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b78db3c",
  null
  
)

export default component.exports